import { render, staticRenderFns } from "./13-ColorScale.vue?vue&type=template&id=81f07b50&scoped=true"
import script from "./13-ColorScale.vue?vue&type=script&lang=ts"
export * from "./13-ColorScale.vue?vue&type=script&lang=ts"
import style0 from "./13-ColorScale.vue?vue&type=style&index=0&id=81f07b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f07b50",
  null
  
)

export default component.exports